
import moment from "moment";

export const getDateLabel = (logtime) => {
  if (!logtime?.date) return "";

  const date = moment(logtime.date);
  const today = moment();
  const yesterday = moment().subtract(1, "days");
  const tomorrow = moment().add(1, "days");

  if (date.isSame(today, "day")) return "Today";
  if (date.isSame(yesterday, "day")) return "Yesterday";
  if (date.isSame(tomorrow, "day")) return "Tomorrow";

  return date.format("DD MMMM");
};